export { default } from 'ember-on-resize-modifier/modifiers/on-resize';